<script>
import compoment from '@/components/draggable/CustomComponents/Input/DInputEditor'
export default {
  name: 'DSeoKeywordEditor',
  extends: compoment
}
</script>
